import React, { FC } from 'react';

import cn from 'classnames';
import Image from 'next/legacy/image';

import { I18n } from '@utils/index';

import styles from './index.module.less';

type status = 'main'|'history';
interface InfoProps {
    type: status;
    tip?: string;
    className?: string;
}
const ImageList = {
  main: {
    width: 163,
    height: 223,
    url: require('@images/airdrop/airEmpty.webp')
  },
  history: {
    width: 210,
    height: 210,
    url: require('@images/airdrop/historyEmpty.webp')
  }
};
export const AirdropEmpty: FC<InfoProps> = (props) => {
  const { type, tip, className } = props;
  return (
    <div className={cn(styles.container, className)}>
        <div className={cn({
          [styles.img]: type === 'history',
          [styles.imgEmpty]: type === 'main'
        })}>
          <Image src={ImageList[type].url} width={ImageList[type].width} height={ImageList[type].height} alt="kikitrade" />
        </div>
        <p className={styles.tip}>{tip || I18n.t('hXhAwwbD')}</p>
    </div>
  );
};
